import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import InputRange from 'react-input-range';
import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';
import './InputRange.css';
import { getTranslatedString } from 'helpers/i18n';

const numberOfMinutesInADay = 1440;
const elevenFiftyNineInMinutes = 1439;

const styles = {
  tableWrapper: {
    position: 'relative',
  },
  table: {
    width: '100%',
  },
  checkboxCell: {
    width: '30px',
  },
  dayCell: {
    width: '40px',
  },
  headerDayCell: {
    width: '40px',
    backgroundColor: '#efefef',
  },
  headerCheckboxCell: {
    width: '30px',
    backgroundColor: '#efefef',
  },
  headerCell: {
    backgroundColor: '#efefef',
    textAlign: 'center',
  },
  tableRow: {
    borderBottom: '1px solid rgba(0,0,0,0.1)',
  },
  unavailable: {
    textAlign: 'center',
    fontSize: '16px',
    color: 'rgba(0,0,0,0.3)',
    backgroundColor: '#f6f6f6',
    display: 'table-cell',
    verticalAlign: 'inherit',
    padding: '28px',
  },
  sliderWrapper: {
    padding: '4rem 45px 3rem 3rem',
    position: 'relative',
    top: '-8px',
  },
  actionsWrapper: {
    textAlign: 'center',
    padding: '2rem',
  },
  saveButton: {
    color: 'white',
    height: '40px',
    margin: 'auto',
  },
  allDayPicked: {
    color: AccentColor(),
    textAlign: 'center',
    fontSize: '16px',
    display: 'table-cell',
    verticalAlign: 'inherit',
    padding: '28px',
  },
};

const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
class AvailabilitiesForm extends Component {
  constructor(props) {
    super(props);
    this.state = this.initStateFromProps(props.weekData);
  }

  translateText = (text) => getTranslatedString(text);

  initStateFromProps = (weekData) => {
    let daysData = {},
      checkedDaysCount = 0;

    WEEK_DAYS.forEach((dayName) => {
      let dayData = weekData[dayName];

      daysData[dayName] = {
        name: dayName,
        available: !!dayData && !!dayData.available,
        range: {
          min: dayData ? this.timeToMinutes(dayData.start_time) : 540,
          max: dayData ? this.timeToMinutes(dayData.end_time) : 1020,
        },
      };
      if (dayData && dayData.available) checkedDaysCount += 1;
    });

    return {
      daysData: daysData,
      checkedDaysCount: checkedDaysCount,
      dirty: false,
    };
  };

  toggleAvailable = (dayNames, checked) => {
    let newDaysData = { ...this.state.daysData };
    let diff = 0;

    dayNames.forEach((dayName) => {
      let newRange = { ...newDaysData[dayName].range };
      if (newDaysData[dayName].available !== checked) diff += 1;
      if (newRange.min === newRange.max) {
        newRange.min = 540;
        newRange.max = 1020;
      }
      newDaysData[dayName] = {
        ...newDaysData[dayName],
        available: checked,
        range: newRange,
      };
    });

    this.setState({
      daysData: newDaysData,
      checkedDaysCount: checked
        ? this.state.checkedDaysCount + diff
        : this.state.checkedDaysCount - diff,
      dirty: true,
    });
  };

  toggleWeek = () => {
    if (this.state.checkedDaysCount === 7) {
      this.toggleAvailable(WEEK_DAYS, false);
    } else {
      this.toggleAvailable(WEEK_DAYS, true);
    }
  };

  formatTime = (value) => {
    const realVal = value / 60.0;
    let hour = Math.floor(realVal);
    const min = value - hour * 60;
    let amPm = 'AM';
    if (hour === 0) {
      hour = 12;
    } else if (hour === 12) {
      amPm = 'PM';
    } else if (hour === 24) {
      hour = 12;
      amPm = 'AM';
    } else if (hour > 12) {
      hour = hour - 12;
      amPm = 'PM';
    }
    const minStr = '0' + min;
    return hour + ':' + minStr.substring(minStr.length - 2) + ' ' + amPm;
  };

  timeToMinutes = (timeStr) => {
    if (timeStr.length === 7) timeStr = '0' + timeStr;

    let hour = parseInt(timeStr.substring(0, 2), 10);
    let min = parseInt(timeStr.substring(3, 5), 10);
    let amPm = timeStr.substring(6, 8);
    if (amPm === 'AM' && hour === 12) {
      return min;
    } else if (amPm === 'AM' || hour === 12) {
      return hour * 60 + min;
    } else {
      return (hour + 12) * 60 + min;
    }
  };

  setDayRange = (dayName, value) => {
    let newDaysData = { ...this.state.daysData };
    let rangeValue = value;
    if (rangeValue.max === numberOfMinutesInADay) {
      rangeValue.max = elevenFiftyNineInMinutes;
    }

    newDaysData[dayName] = {
      ...newDaysData[dayName],
      range: rangeValue,
    };
    this.setState({
      daysData: newDaysData,
      dirty: true,
    });
  };

  submitAvailability = () => {
    let requestBody = {
      available: this.state.checkedDaysCount > 0,
      availabilities: {},
    };
    WEEK_DAYS.forEach((dayName) => {
      const dayData = this.state.daysData[dayName];
      requestBody.availabilities[dayName] = {
        available: dayData.available,
        start_time: this.formatTime(dayData.range.min),
        end_time: this.formatTime(dayData.range.max),
      };
    });
    this.props.submitAvailability(requestBody);
  };

  render() {
    const { daysData } = this.state;
    const { disabled } = this.props;

    return (
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableRow}>
              <th style={styles.headerCheckboxCell}>
                <Checkbox
                  disabled={disabled}
                  checked={this.state.checkedDaysCount === 7}
                  indeterminate={![0, 7].includes(this.state.checkedDaysCount)}
                  onClick={this.toggleWeek}
                />
              </th>
              <th style={styles.headerDayCell}>
                {this.translateText('landlordPortal.availabilitiesForm.day')}
              </th>
              <th style={styles.headerCell}>
                {this.translateText('landlordPortal.availabilitiesForm.timeOfDay')}
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.values(daysData).map((day) => {
              return (
                <tr key={`key_${day.name}`} style={styles.tableRow}>
                  <td style={styles.checkboxCell}>
                    <Checkbox
                      disabled={disabled}
                      value={day.name}
                      checked={day.available}
                      onChange={(event) => this.toggleAvailable([day.name], event.target.checked)}
                    />
                  </td>
                  <td style={styles.dayCell}>
                    {this.translateText(
                      `landlordPortal.availabilitiesForm.${day.name.toLowerCase()}`
                    ).substring(0, 3)}
                  </td>
                  <td>{this.renderTimeRangePicker(day)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div style={styles.actionsWrapper}>{this.renderUpdateButton()}</div>
      </div>
    );
  }

  renderUpdateButton = () => {
    const { dirty } = this.state;
    if (this.props.disabled) return;
    return (
      <FlatButton
        label={getTranslatedString('landlordPortal.amenities.form.update_availability')}
        primary={true}
        backgroundColor={AccentColor()}
        hoverColor="grey"
        disabled={!dirty}
        style={{
          ...styles.saveButton,
          backgroundColor: dirty ? 'rgb(255, 52, 52)' : 'grey',
        }}
        onClick={this.submitAvailability}
      />
    );
  };

  renderTimeRangePicker = (dayData) => {
    const minTimeInMinutes = 0;
    const maxTimeInMinutes = 1439;
    const thirtyMinutes = 30;

    if (!dayData.available) {
      return (
        <div style={styles.unavailable}>
          {getTranslatedString('landlordPortal.amenities.notAvailable')}
        </div>
      );
    } else if (this.props.disableTimePicking) {
      return (
        <div style={styles.allDayPicked}>
          {getTranslatedString('landlordPortal.amenities.allDay')}
        </div>
      );
    }

    return (
      <div style={styles.sliderWrapper}>
        <InputRange
          disabled={this.props.disabled}
          formatLabel={this.formatTime}
          step={thirtyMinutes}
          minValue={minTimeInMinutes}
          maxValue={maxTimeInMinutes}
          value={dayData.range}
          onChange={(value) => this.setDayRange(dayData.name, value)}
        />
      </div>
    );
  };
}

export default AvailabilitiesForm;
